import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { colorsConstants } from "../../utils/constants/colors.constants";

let CreateDivisionDialogComponent = {
    selector: "vcDivisionCreateDialog",
    templateUrl:
        "/angular/components/division/division-create-dialog.component.html",
    bindings: {
        division: "=?",
    },
    controller: class CreateDivisionDialogController {
        // * bindings for typescript compiler *
        public division?: any;
        // ************************************

        private readonly $scope: any;

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private dataProvider: DivisionDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private divisionCopy: Division;
        private divisionCampaigns: Array<Campaign> = [];
        private divisionSpecificUsers: Array<User> = [];

        public colors = colorsConstants.divisionColors;
        public saving: boolean = false;
        public __env: any;
        public campaignSearch: string = "";
        public campaigns: Array<Campaign> = [];
        public usersLoading: boolean;

        constructor(
            $scope: any,
            __env: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            DivisionDataProvider: DivisionDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.dataProvider = DivisionDataProvider;
            this.campaignDataProvider = CampaignDataProvider;

            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.campaigns = organisation.campaigns;
                    this.dataProvider
                        .getDivisionCampaigns()
                        .then((campaigns: Array<Campaign>) => {
                            this.divisionCampaigns = campaigns;
                            this.setDivisionsCampaigns();
                        });
                });
        }

        $onInit() {
            this.division = new Division(_.cloneDeep(this.division));
            this.divisionCopy = _.cloneDeep(this.division);
        }

        cancel(): void {
            this.dialog.cancel();
        }

        setDivisionsCampaigns(): void {
            for (let i = 0; i < this.campaigns.length; i++) {
                this.campaigns[i].selected = this.activeCampaigns(
                    this.campaigns[i]
                );
            }
        }

        activeCampaigns(campaign: Campaign): boolean {
            for (let i = 0; i < this.divisionCampaigns.length; i++) {
                if (
                    this.divisionCampaigns[i].campaignid == campaign.campaignid
                ) {
                    if (!this.division) campaign.disabled = true;
                    else
                        campaign.disabled = this.setDisabled(
                            campaign.campaignid
                        );
                    return true;
                }
            }
            return false;
        }

        setDisabled(campaignid: string): boolean {
            for (let i = 0; i < this.division.campaigns.length; i++) {
                if (this.division.campaigns[i].campaignid == campaignid) {
                    return false;
                }
            }
            return true;
        }

        checkDisabled(): Array<Campaign> {
            return this.campaigns.filter((campaign: Campaign) => {
                if (!campaign.disabled && campaign.selected) return campaign;
            });
        }

        selectColor(color: string): void {
            this.division.color = color;
        }

        saveDivision(division: Division): void {
            if (division.isValid()) {
                this.saving = true;
                division.campaigns = this.checkDisabled();
                if (division.id) {
                    this.addRemovedCampaignsToDefaultDivision(
                        division,
                        this.divisionCopy
                    );
                    this.dataProvider
                        .updateDivision(division)
                        .then((updatedDivision: object) => {
                            this.toast.success("Division updated");
                            this.dialog.hide(updatedDivision);
                        });
                } else {
                    this.dataProvider
                        .createDivision(division)
                        .then((createdDivision: Division) => {
                            createdDivision.campaigns.forEach((campaign) => {
                                this.dataProvider.spliceCampaign(
                                    campaign,
                                    this.dataProvider.divisions[
                                        this.dataProvider.divisions.length - 1
                                    ].campaigns
                                );
                            });
                            this.toast.success(
                                "Division created. It may take a few minutes to appear on the map."
                            );
                            this.dialog.hide(createdDivision);
                        });
                }
            }
        }

        addRemovedCampaignsToDefaultDivision(
            divisionNew: Division,
            divisionOld: Division
        ): void {
            let missingCampaigns = [];

            //find the campaigns which were on the old division, but not on the new version
            angular.forEach(divisionOld.campaigns, (oldCampaign: Campaign) => {
                let found = false;
                angular.forEach(
                    divisionNew.campaigns,
                    (newCampaign: Campaign) => {
                        if (newCampaign.campaignid == oldCampaign.campaignid) {
                            found = true;
                        }
                    }
                );
                if (!found) {
                    missingCampaigns.push(oldCampaign);
                }
            });

            angular.forEach(divisionNew.campaigns, (campaign: Campaign) => {
                this.dataProvider.spliceCampaign(
                    campaign,
                    this.dataProvider.divisions[
                        this.dataProvider.divisions.length - 1
                    ].campaigns
                );
            });

            this.dataProvider.addToDefaultCampaigns(missingCampaigns);
        }

        deleteDivision(division: Division, $event: any): void {
            this.usersLoading = true;
            this.dataProvider
                .getDivisionUsers(this.division.divisionid, true)
                .then(
                    (users: object[]) => {
                        this.usersLoading = false;
                        if (users.length) {
                            this.changeUserPermissions(users, $event);
                        } else {
                            this.dialog
                                .delete({
                                    targetEvent: $event,
                                    locals: {
                                        title: "Delete Division?",
                                        bodyText:
                                            "They will be permanently deleted",
                                    },
                                })
                                .then(() => {
                                    this.dataProvider
                                        .deleteDivision(
                                            this.division.divisionid
                                        )
                                        .then(
                                            () => {
                                                this.toast.success(
                                                    "Division Deleted"
                                                );
                                            },
                                            (error: object) => {
                                                console.log(error);
                                            }
                                        );
                                });
                        }
                    },
                    (error: object) => this.toast.error(error)
                );
        }

        changeUserPermissions(divisionUsers: object[], $event: any): void {
            this.dialog.show({
                component: "vc-division-user-list",
                targetEvent: $event,
                scope: this.$scope,
                locals: {
                    division: this.division,
                    divisionUsers: divisionUsers,
                },
                size: "large",
            });
        }

        disableSave(): boolean {
            let selectedCampaigns = this.campaigns.filter(
                (campaign: Campaign) => campaign.selected && !campaign.disabled
            );
            return !selectedCampaigns.length;
        }
    },
};

angular
    .module("division", [])
    .component(
        CreateDivisionDialogComponent.selector,
        CreateDivisionDialogComponent
    );
